import { withSentryReactRouterV6Routing } from '@chilipiper/sentry'
import React from 'react'
import { Routes } from 'react-router-dom'

const SentryRoutes = withSentryReactRouterV6Routing(Routes)

export const SentryRouter = ({ children }: React.PropsWithChildren) => {
  return <SentryRoutes>{children}</SentryRoutes>
}
